import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from '@aveva/connect-web-core';
import { Observable } from 'rxjs';

@Injectable()
export class ErmCapabilityGuard implements CanActivate {
  private readonly authenticationService = inject(AuthenticationService);

  public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationService.getUser()
      .then((user) => {
        if (!user) {
          this.authenticationService.navigateToSignIn();
          return false;
        }
        return true;
      })
      .catch((error) => {
        console.error(error);
        this.authenticationService.signout();
        return false;
      });
  }
}
